export const version = '2.9.29';
//# sourceMappingURL=version.js.map